import { ContactData } from 'src/Libs/user/models'

type AddressKeysType = keyof Pick<ContactData, 'Address' | 'PlaceOR' | 'PLZ' | 'Land'>

export const addressKeys: AddressKeysType[] = ['Address', 'Land', 'PLZ', 'PlaceOR']

/**
 * Function that can compare two addresses(ex: user address and company address)
 * @param firstAddress first address
 * @param secondAddress second address
 * @returns boolean, true if addresses are same
 */
export const compareAddresses = (firstAddress: ContactData | undefined, secondAddress: ContactData | undefined): boolean =>
  addressKeys.every(key => firstAddress?.[key] === secondAddress?.[key])
